/** A resource failure never invalidates another request's credentials. */
export const SESSION_ENDED = "bayesprep:session-ended";
export function createSessionFailureHandler({
  storageKey = "token",
  clearKeys = [storageKey, "tenantCode", "isFirstTimeLogin"],
} = {}) {
  const checks = new Map();
  let notice = "";
  function readSessionNotice() {
    return notice;
  }
  function takeSessionNotice() {
    const previous = notice;
    notice = "";
    return previous;
  }
  function endSession(
    token,
    message = "Your session has expired. Please sign in again.",
  ) {
    if (!token || localStorage.getItem(storageKey) !== token) return false;
    clearKeys.forEach((key) => localStorage.removeItem(key));
    notice = message;
    window.dispatchEvent(new CustomEvent(SESSION_ENDED));
    return true;
  }
  async function confirmSessionFailure(token) {
    if (!token || localStorage.getItem(storageKey) !== token) return false;
    if (!checks.has(token))
      checks.set(
        token,
        (async () => {
          try {
            const response = await fetch("/api/auth/me", {
              headers: {
                Authorization: `Bearer ${token.replace(/^Bearer /, "")}`,
              },
              signal: AbortSignal.timeout(7000),
            });
            return [401, 403].includes(response.status)
              ? endSession(token)
              : false;
          } catch {
            return false;
          } finally {
            checks.delete(token);
          }
        })(),
      );
    return checks.get(token);
  }
  return {
    readSessionNotice,
    takeSessionNotice,
    endSession,
    confirmSessionFailure,
  };
}
